export const generateAssetsId = (id: string, type: "2d" | "3d") => {
  return `${id}_${type}`;
};
